<template lang="pug">
article.opportunities__article
  .opportunities__description
    h4.opportunities__title {{ props.article.title }}
    p.opportunities__text {{ props.article.text }}
  picture.opportunities__image
    source(
      :type='pictureImgData[0].type'
      :srcset='pictureImgData[0].imgSrcMin'
      media='(max-width: 767px)')
    source(
      :type='pictureImgData[0].type'
      :srcset='pictureImgData[0].imgSrc')
    source(
      :type='pictureImgData[1].type'
      :srcset='pictureImgData[1].imgSrcMin'
      media='(max-width: 767px)')
    source(
      :type='pictureImgData[1].type'
      :srcset='pictureImgData[1].imgSrc')
    source(
      :srcset='pictureImgData[2].imgSrcMin'
      media='(max-width: 767px)')
    img(
      :src='pictureImgData[2].imgSrc'
      loading='lazy'
      :alt='pictureImgData[2].alt')
  picture.opportunities__image-mobile
</template>

<script setup>
const props = defineProps({
  article: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    pictureData: {
      type: Object,
      default: () => { },
    },
  },
})

const pictureImgData = computed(() => props.article.pictureData)
</script>

<style lang='scss' scoped>
img {
  max-width: 100%;
}

.opportunities {
  &__article {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: clamp(2.25rem, -0.475rem + 8.07vw, 4.688rem);
  }

  &__description {
    max-width: 335px;

    @media (--mobile-viewport-df) {
      max-width: 100%;
    }
  }

  &__title {
    color: var(--color-main);
    font-size: clamp(1.25rem, 0.97rem + 0.83vw, 1.5rem);
  }

  &__title,
  &__text {
    margin-bottom: 16px;
  }

  &__text {
    color: var(--light3-grey-color);
  }

  &__image {
    max-width: 706px;
  }
}
</style>
